var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { removeKey } from '@pcty/utils';
import { getAutomation, getDebug } from '@citrus/runtime';
import { StackableGroup as Component } from './Button.styled';
import { cx, css as emotionCss } from 'emotion';
var VERSION = '5.11.3-CDS4220.0';
var StackableButtonGroup = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, css = _a.css, automationId = _a.automationId, _c = _a.__TYPE, __TYPE = _c === void 0 ? 'StackableButtonGroup' : _c, other = __rest(_a, ["children", "className", "css", "automationId", "__TYPE"]);
    var _css = cx((_b = {},
        _b[emotionCss(css)] = true,
        _b), className || '');
    other = removeKey(other, 'id');
    return (React.createElement(Component, __assign({ className: _css, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), getButtons(children)));
});
var getButtons = function (children) {
    var buttonTypes = ['PrimaryButton', 'DefaultButton', 'SecondaryButton', 'BorderlessButton'];
    return React.Children.toArray(children)
        .filter(function (child) { return child.props && buttonTypes.includes(child.props.__TYPE); })
        .map(function (x) { return React.cloneElement(x, { removeSiblingMargin: true }); });
};
StackableButtonGroup.defaultProps = {
    __TYPE: 'StackableButtonGroup',
};
export default StackableButtonGroup;
